import moment from 'moment';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { SingleDatePicker } from 'react-dates';
import { change } from 'redux-form';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';

import FieldError from '../../form/FieldError';
import { projectTimezoneIdSelector } from '../../../reducers/projects';
import { timezonesSelector, getTimezoneOffset } from '../../../reducers/timezones';
import { getProjectTime } from '../../../helpers/timezone';
// import { timeZoneHelperSelector } from '../TimeZone/TimeZoneHelpers';

if (__CLIENT__) {
  // $react-dates-width-input: 130px !default;
  require('react-dates/lib/css/_datepicker.css');
}

const EditorSelector = createSelector(
  [timezonesSelector, projectTimezoneIdSelector],
  (timezones, projectTimezoneId) =>  ({
    timezoneOffset: getTimezoneOffset(timezones, projectTimezoneId),
  }),
);
// const EditorSelector = createSelector(
//   [timeZoneHelperSelector],
//   (timeZoneHelper) => ({ timeZoneHelper }),
// );
@connect(EditorSelector)
export default class Editor extends PureComponent {
  static propTypes = {
    input: PropTypes.object,
    meta: PropTypes.object,
    toggleEditor: PropTypes.func,
    uid: PropTypes.string,
    dispatch: PropTypes.func,
    containerClassName: PropTypes.string,
    containerStyle: PropTypes.object,
    wrapperClassName: PropTypes.string,
    wrapperStyle: PropTypes.object,
    timezoneOffset: PropTypes.number,
    // timeZoneHelper: PropTypes.object,
  };

  constructor(props) {
    // console.log('props', props.input);
    super(props);
    this.state = {
      focused: false,
      date: (props.input && props.input.value)
        ? moment(props.input.value)
        : null,
    };

    this.onDateChange = this.onDateChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
  }

  onDateChange(date) {
    const {
      uid,
      input,
      meta: { dispatch },
      timezoneOffset,
      // timeZoneHelper,
    } = this.props;
    const fieldName = input.name;
    // console.log('eeee', fieldName);

    if (date) {
      const newDate = getProjectTime(timezoneOffset, date);
      // const newDate = timeZoneHelper.getProjectTime(date);
      dispatch(change(uid, fieldName, newDate));
      this.setState({ date: newDate });
    } else {
      dispatch(change(uid, fieldName, null));
      this.setState({ date: null });
    }
  }

  onFocusChange({ focused }) {
    this.setState({ focused });
  }

  render() {
    const {
      meta,
      wrapperClassName,
      wrapperStyle,
      containerClassName,
      containerStyle,
    } = this.props;
    const { focused, date } = this.state;

    const displayEditor = (
      <div className={wrapperClassName} style={wrapperStyle}>
        <div className={containerClassName} style={containerStyle}>
          <SingleDatePicker
            numberOfMonths={1}
            enableOutsideDays
            showClearDate
            id="date_input"
            date={date}
            focused={focused}
            onDateChange={this.onDateChange}
            onFocusChange={this.onFocusChange}
            isOutsideRange={() => {}}
          />
          {meta && <FieldError meta={meta} />}
        </div>
      </div>
    );

    return displayEditor;
  }
}



// WEBPACK FOOTER //
// ./src/components/types/Date/Editor.js